import React, { useState } from "react";
import { useAuthStore } from "../stores/auth";
import eye from "../assets/icons/eye.svg";
import eyeSlash from "../assets/icons/eye-off.svg";
import { useNavigate } from "react-router-dom";
import { showToastError, showToastSuccess } from "../services/toast";
import { resetPassword } from "../api/login";
import {
  AuthCopyright,
  AuthField,
  AuthFooterLink,
  AuthShell,
  AuthSubmit,
  PasswordToggle,
} from "../components/ui/page/AuthShell";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  // Store
  const {
    password,
    setPassword,
    verifyPassword,
    setVerifyPassword,
    showPassword,
    setShowPassword,
    reset,
  } = useAuthStore();

  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== verifyPassword) {
      showToastError("Les mots de passe doivent être identiques.");
      return;
    }
    if (verifyPassword.length < 8) {
      showToastError("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }

    if (!token) {
      showToastError("Token is missing.");
      return;
    }

    setIsLoading(true);
    resetPassword(token, verifyPassword)
      .then((response) => {
        if (response?.status === 200) {
          showToastSuccess("Le mot de passe a bien été réinitialisé !");
          navigate("/");
          reset();
        }
      })
      .catch((err) => {
        if (
          err?.response?.data?.message ===
          "Password can't contain personal information"
        ) {
          showToastError(
            "Votre mot de passe ne peut pas contenir d'informations personnelles",
          );
        } else {
          showToastError("Une erreur est survenue");
        }
      })
      .finally(() => setIsLoading(false));
  };

  const passwordToggle = (
    <PasswordToggle
      visible={showPassword}
      onToggle={() => setShowPassword(!showPassword)}
      icon={showPassword ? eye : eyeSlash}
    />
  );

  return (
    <AuthShell
      eyebrow="Sécurisez votre accès"
      headline="Nouveau mot de passe"
      description="Choisissez un mot de passe robuste et accédez à votre espace en toute confiance."
      title="Réinitialisation"
      subtitle="Renseignez votre nouveau mot de passe."
      footer={
        <>
          <AuthFooterLink onClick={() => navigate("/")}>
            Retour à la connexion
          </AuthFooterLink>
          <span aria-hidden="true" className="text-slate-300">
            •
          </span>
          <AuthCopyright />
        </>
      }
    >
      <form onSubmit={handleSubmit} className="mt-7 flex flex-col gap-4">
        <AuthField
          label="Mot de passe"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={setPassword}
          required
          autoComplete="new-password"
          trailing={passwordToggle}
        />

        <AuthField
          label="Vérification mot de passe"
          type={showPassword ? "text" : "password"}
          value={verifyPassword}
          onChange={setVerifyPassword}
          required
          autoComplete="new-password"
          trailing={passwordToggle}
        />

        <p className="font-Nunito text-xs text-slate-500">
          Au moins 8 caractères, avec majuscule, minuscule, chiffre et symbole.
        </p>

        <AuthSubmit isLoading={isLoading} loadingLabel="Réinitialisation...">
          Réinitialiser
        </AuthSubmit>
      </form>
    </AuthShell>
  );
};

export default ResetPassword;
